const getDownloadURL = (assetURL: string): string => `/api/download?asset=${btoa(assetURL)}`;

export default getDownloadURL;
